import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';

import FormCrearLicencia from './FormCrearLicencia';

import updateLicenciaPorId from '../../../graphql/mutations/rrhh/updateLicenciaPorId.graphql';
import getLicenciaPorId from '../../../graphql/querys/rrhh/getLicenciaPorId.graphql';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(updateLicenciaPorId, {
    name: 'updateLicenciaPorId',
  })
)
class EditarLicencia extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      licencia: {},
      loading: true,
    };

    this.props.client
      .query({
        query: getLicenciaPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const licencia = res.data.getLicenciaPorId;
        this.setState({
          loading: false,
          licencia: licencia,
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);

        Modal.error({
          title: 'Error en la creacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });

    this.onCancel = this.onCancel.bind(this);
  }

  guardarLicencia = licencia => {
    this.setState(
      {
        licencia: {
          ...this.state.licencia,
          ...licencia,
        },
      },
      function() {
        let nuevaLicencia = licencia;

        nuevaLicencia.fechaInicio = nuevaLicencia.fechaInicio.toDate();
        nuevaLicencia.fechaFin = nuevaLicencia.fechaFin.toDate();
        delete nuevaLicencia.__typename;
        delete nuevaLicencia._id;

        this.props
          .updateLicenciaPorId({
            variables: {
              _id: this.props.match.params.id,
              nuevaLicencia: nuevaLicencia,
            },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            notification.success({
              message: 'Actualizacion Correcta',
              description: 'Se ha registrado los nuevos datos del licencia',
            });

            this.props.history.push('/rrhh/licencias');
          })
          .catch(err => {
            console.log('Error en la actualizacion del licencia');
            console.log(err);

            Modal.error({
              title: 'Error en la actualizacion de los datos del licencia',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      }
    );
  };

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Licencia</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Editar Licencia
          </h2>
          <br />
          <div style={estiloContent}>
            <FormCrearLicencia
              className="formularios"
              onSubmit={this.guardarLicencia}
              onAnterior={() => this.props.history.push('/rrhh/licencias')}
              datos={this.state.licencia}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarLicencia);
